'use strict';

exports.__esModule = true;
exports.declMod = exports.decl = undefined;

var _decls = require('./lib/decls');

var _decls2 = _interopRequireDefault(_decls);

var _BaseComponent = require('./lib/BaseComponent');

var _BaseComponent2 = _interopRequireDefault(_BaseComponent);

var _ClassNameBuilder = require('./lib/ClassNameBuilder');

var _ClassNameBuilder2 = _interopRequireDefault(_ClassNameBuilder);

var _simpleComponent = require('./lib/simpleComponent');

var _simpleComponent2 = _interopRequireDefault(_simpleComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultNaming = new _ClassNameBuilder2.default({
        elementSeparator: '-',
        modSeparator: '_',
        modValueSeparator: '_'
}),
    defaultDecls = (0, _decls2.default)({}, _BaseComponent2.default, defaultNaming);

var decl = defaultDecls.decl,
    declMod = defaultDecls.declMod;
exports.decl = decl;
exports.declMod = declMod;
exports.default = (0, _simpleComponent2.default)(defaultNaming);